import PortfolioEdit from '../../PortfolioEdit';


export const RouteList = [
    {
        path: "/portfoliosettings/editPortfolio",
        component: PortfolioEdit
    },
   
]